<template>
  <SvoiButton
    :name="name"
    :theme="theme"
    :theme-type="themeType"
    :size="size"
    :disabled="disabled"
    :icon-left="iconLeft"
    :icon-right="iconRight"
    :border-radius="borderRadius"
    :tabindex="tabindex"
    :qa-locator="qaLocator"
    :loading="loading"
    :loader-icon-left="loaderIconLeft"
    :loader-icon-right="loaderIconRight"
    @click="$emit('click')"
  />
</template>

<script lang="ts" setup>
import { SvoiButton } from '@svoi-ui/components/button'

defineProps<{
  name?: string
  theme?: string
  themeType?: string
  size?: string
  disabled?: boolean
  iconLeft?: string
  iconRight?: string
  borderRadius?: string
  tabindex?: number
  qaLocator?: string
  loading?: boolean
  loaderIconLeft?: boolean
  loaderIconRight?: boolean
}>()

defineEmits(['click', 'mouseover', 'mouseleave', 'focus'])
</script>
